module.exports = __webpack_public_path__ + "img/4-01-05-numbers.6aa33540.svg";